import styled from 'styled-components';

export const Container = styled.div`
  min-height: 600px;
`;

export const ModalTitle = styled.span`
  font-weight: bold;
  font-size: 20px;
  color: #031795;
`

export const ButtonsContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 12px;
  margin-right: 12px;

  button + button {
    margin-left: 12px;
  }
`;
